<template>
    <div class="filter-base">
        <div
            v-if="title"
            class="title"
        >
            {{ title }}
        </div>

        <slot name="default"></slot>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    title?: string
}>()
</script>

<style lang="scss" scoped>
.filter-base {
    width: 100%;
    margin: 0;
    padding: 0 0 0 10px;

    .title {
        margin: 0 0 10px;
        padding-left: 10px;

        font-family: $effra-font-stack;
        font-size: 14px;
        text-transform: uppercase;

        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0.05em;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
}
</style>
